import { Component } from '@theme/component';
import { sectionRenderer } from '@theme/section-renderer';

class HoverNavigation extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.bind();
  }
  updatedCallback() {
    super.updatedCallback();
    this.bind();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.controller?.abort();
    clearTimeout(this.closeTimer);
  }
  bind() {
    this.controller?.abort();
    clearTimeout(this.closeTimer);
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const hover = matchMedia('(hover: hover) and (pointer: fine) and (min-width:1101px)');
    const details = [...this.querySelectorAll(':scope > details')];
    const closeOthers = current => details.forEach(item => { if (item !== current) item.open = false; });
    for (const item of details) {
      item.addEventListener('pointerenter', event => {
        if (!hover.matches || event.pointerType === 'touch') return;
        clearTimeout(this.closeTimer);
        closeOthers(item);
        item.open = true;
      }, options);
      item.addEventListener('pointerleave', event => {
        if (!hover.matches || event.pointerType === 'touch') return;
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => {
          if (!item.contains(document.activeElement)) item.open = false;
        }, 240);
      }, options);
      item.addEventListener('toggle', () => { if (item.open) closeOthers(item); }, options);
      item.addEventListener('focusout', event => {
        if (!item.contains(event.relatedTarget) && !item.matches(':hover')) item.open = false;
      }, options);
      item.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        clearTimeout(this.closeTimer);
        item.open = false;
        item.querySelector('summary')?.focus();
      }, options);
    }
    this.querySelectorAll(':scope > a').forEach(link => {
      link.addEventListener('pointerenter', () => {
        if (hover.matches) { clearTimeout(this.closeTimer); closeOthers(null); }
      }, options);
      link.addEventListener('focus', () => closeOthers(null), options);
    });
  }
}

class ProductMenu extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.load();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.controller?.abort();
    this.loading = false;
  }
  async load() {
    if (!this.dataset.source || this.loaded || this.loading) return;
    this.loading = true;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    try {
      const url = new URL(this.dataset.source, location.origin);
      url.searchParams.set('sort_by', 'created-descending');
      url.searchParams.delete('page');
      const html = await sectionRenderer.getSectionHTML('mavolira-menu-products', true, url, signal);
      if (signal.aborted || !this.isConnected) return;
      const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-product-menu-items]');
      if (!content) throw new Error('Missing product menu content');
      this.querySelector('[data-product-menu-items]')?.replaceWith(content);
      this.loaded = true;
    } catch {
      if (signal.aborted) return;
      const container = this.querySelector('[data-product-menu-items]');
      if (container) {
        const message = document.createElement('p');
        message.className = 'ms-nav-products-empty';
        message.textContent = this.dataset.error;
        container.replaceChildren(message);
        container.removeAttribute('aria-busy');
      }
    } finally {
      this.loading = false;
    }
  }
}

if (!customElements.get('ms-hover-navigation')) customElements.define('ms-hover-navigation', HoverNavigation);
if (!customElements.get('ms-product-menu')) customElements.define('ms-product-menu', ProductMenu);
